<a href="javascript:void(0)" (click)="showCamReport()">
  <ng-content></ng-content>
</a>

<div
  class="modal fade in"
  [id]="modalId"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    overflow: auto;
    color: #222 !important;
  "
>
  <form #f="ngForm" novalidate>
    <div class="modal-dialog cam-modal-dialog modal-dialog-centered" role="document">
      <div cdkDrag [cdkDragDisabled]="isMobile" cdkDragRootElement=".cdk-overlay-pane" class="modal-content cam-modal-content">
        
        <!-- Header -->
        <div cdkDragHandle class="modal-header cam-modal-header">
          <div class="cam-title-wrapper">
            <h6 class="cam-modal-title">CAM Report</h6>

            <span class="cam-badge" *ngIf="applicationNumber">
              <span class="badge-label">App No:</span>
              <strong class="badge-val">{{ applicationNumber }}</strong>
            </span>

            <span class="cam-badge" *ngIf="borrowerName">
              <span class="badge-label">Borrower:</span>
              <strong class="badge-val">{{ borrowerName }}</strong>
            </span>

            <span class="cam-badge" *ngIf="resData?.Item1?.[0]?.LoanAcNo || resData?.Item1?.[0]?.LoanNo">
              <span class="badge-label">Loan No:</span>
              <strong class="badge-val">{{ resData?.Item1?.[0]?.LoanAcNo || resData?.Item1?.[0]?.LoanNo }}</strong>
            </span>
          </div>

          <button
            type="button"
            (click)="OnClose()"
            class="close-btn"
            aria-label="Close"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body cam-modal-body" id="camModalPrintBody" (touchmove)="$event.stopPropagation()">

          <div class="content" *ngIf="resData">
            
            <!-- Loan Details -->
            <ng-container *ngIf="resData?.Item1?.length">
              <div class="cam-section-banner">
                <i class="fas fa-info-circle"></i>
                <h6 class="titleHeadP">Loan Details</h6>
              </div>
              <div class="cam-card-container">
                <app-loan-subcard-info
                  [loandata]="resData?.Item1[0]"
                ></app-loan-subcard-info>
              </div>
            </ng-container>

            <!-- Financial Details -->
            <ng-container *ngIf="resData?.Item16?.length">
              <div class="cam-section-banner">
                <i class="fas fa-coins"></i>
                <h6 class="titleHeadP">Financial Details</h6>
              </div>
              <div class="cam-card-container">
                <app-loan-financial-info
                  [financialdata]="resData?.Item16"
                ></app-loan-financial-info>
              </div>
            </ng-container>

            <!-- Asset Details -->
            <ng-container *ngIf="resData?.asset?.[0]?.Product_Category === 'Vehicle Loan' || resData?.asset?.[0]?.Product_Category === 'Property Loan' || resData?.goldAsset?.length || resData?.LegalAssets?.length || resData?.ValuationAssestsDetails?.length">
              <div class="cam-section-banner">
                <i class="fas fa-building"></i>
                <h6 class="titleHeadP">Asset Details</h6>
              </div>
              <div class="cam-card-container">
                <app-asset-subcard-info
                  [assetData]="resData?.asset[0]"
                  [AssetsAttachment]="resData?.AssetsAttachment"
                  [ApplicationNumber]="resData?.ApplicationNumber[0]"
                  [GoldAssets]="resData?.goldAsset"
                  [LegalAssets]="resData?.LegalAssets"
                  [ValuationAssestsDetails]="resData?.ValuationAssestsDetails"
                  [ValuationAttachments]="resData?.ValuationAttachments"
                ></app-asset-subcard-info>
              </div>
            </ng-container>

            <!-- TAT Details -->
            <div class="cam-section-banner">
              <i class="fas fa-stopwatch"></i>
              <h6 class="titleHeadP">TAT Details</h6>
            </div>
            <div class="cam-card-container">
              <app-tat-report [loanId]="loanId"></app-tat-report>
            </div>

            <!-- Deduction Details -->
            <div class="cam-section-banner">
              <i class="fas fa-receipt"></i>
              <h6 class="titleHeadP">Deduction Details</h6>
            </div>
            <div class="cam-card-container">
              <app-receipt-deduction
                [loanId]="loanId"
              ></app-receipt-deduction>
            </div>

            <!-- Deviation Details -->
            <ng-container *ngIf="resData?.deviation?.length">
              <div class="cam-section-banner">
                <i class="fas fa-exclamation-triangle"></i>
                <h6 class="titleHeadP">Deviation Details</h6>
              </div>
              <div class="cam-card-container">
                <app-deviation-info
                  [data]="resData?.deviation"
                ></app-deviation-info>
              </div>
            </ng-container>

            <!-- Sanction Condition -->
            <ng-container *ngIf="resData?.sanction?.length">
              <div class="cam-section-banner">
                <i class="fas fa-clipboard-check"></i>
                <h6 class="titleHeadP">Sanction Condition</h6>
              </div>
              <div class="cam-card-container">
                <app-sanction-condition
                  [data]="resData?.sanction"
                ></app-sanction-condition>
              </div>
            </ng-container>

            <!-- Documents -->
            <ng-container *ngIf="resData?.documents?.length">
              <div class="cam-section-banner">
                <i class="fas fa-folder-open"></i>
                <h6 class="titleHeadP">Documents</h6>
              </div>
              <div class="cam-card-container">
                <app-attached-document
                  [loanId]="loanId"
                  [ApplicationNumber]="resData?.ApplicationNumber[0]"
                ></app-attached-document>
              </div>
            </ng-container>

            <!-- FOIR Details -->
            <div class="cam-section-banner">
              <i class="fas fa-calculator"></i>
              <h6 class="titleHeadP">FOIR Details</h6>
            </div>
            <div class="cam-card-container">
              <app-foir-card [loanId]="loanId"></app-foir-card>
            </div>

            <!-- Recommendation Details -->
            <ng-container *ngIf="resData?.recommendation?.length">
              <div class="cam-section-banner">
                <i class="fas fa-user-check"></i>
                <h6 class="titleHeadP">Recommendation Details</h6>
              </div>
              <div class="cam-card-container">
                <app-recommendation-card-details [data]="resData?.recommendation"></app-recommendation-card-details>
              </div>
            </ng-container>

            <!-- Customer & Applicant Carousel Section -->
            <div class="cam-section-banner">
              <i class="fas fa-users"></i>
              <h6 class="titleHeadP">Applicant Details & Verification</h6>
            </div>

            <div class="applicant-carousel-wrapper">
              <div
                id="carouselExampleIndicators"
                class="carousel slide"
                data-ride="carousel"
              >
                <!-- Carousel Header Controls -->
                <div class="carousel-nav-bar">
                  <div class="applicant-badge">
                    <i class="fas fa-user-tie"></i>
                    <span>Applicant Profile & Verification Records</span>
                  </div>
                  <div class="carousel-controls" *ngIf="resData?.data?.length > 1">
                    <button
                      type="button"
                      class="btn-carousel-ctrl"
                      href="#carouselExampleIndicators"
                      data-slide="prev"
                    >
                      <i class="fas fa-chevron-left mr-1"></i> Previous Applicant
                    </button>
                    <button
                      type="button"
                      class="btn-carousel-ctrl"
                      href="#carouselExampleIndicators"
                      data-slide="next"
                    >
                      Next Applicant <i class="fas fa-chevron-right ml-1"></i>
                    </button>
                  </div>
                </div>

                <div class="carousel-inner">
                  <div
                    class="carousel-item"
                    [ngClass]="ind == 0 ? 'active' : ''"
                    *ngFor="let item of resData.data; let ind = index"
                  >
                    <div class="row my-2 align-items-start">
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item2">
                        <app-customer-subcard-info
                          [customerData]="resData.data[ind].Item2"
                        ></app-customer-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item9?.length">
                        <app-customer-kyc-subcard-info
                          [customerkycData]="resData.data[ind].Item9"
                        >
                        </app-customer-kyc-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item3?.length">
                        <app-crc-subcard-info
                          [applicationId]="applicationId"
                          [crcData]="resData.data[ind].Item3"
                          [index]="ind"
                        ></app-crc-subcard-info>
                      </div>
                    </div>
                    <div class="row my-2 align-items-start">
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item4?.length">
                        <app-family-subcard-info
                          [familyData]="resData.data[ind].Item4"
                        ></app-family-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item5?.length">
                        <app-income-subcard-info
                          [incomeData]="resData.data[ind].Item5"
                          [applicationNo]="applicationId"
                        ></app-income-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item6?.length">
                        <app-references-subcard-info
                          [referenceData]="resData.data[ind].Item6"
                        >
                        </app-references-subcard-info>
                      </div>
                    </div>

                    <div class="row my-2 align-items-start">
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item10?.length">
                        <app-FI-Question-subcard-info
                          [FIQuestionData]="resData.data[ind].Item10"
                        ></app-FI-Question-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item11?.length">
                        <app-TVR-Question-subcard-info
                          [TVRQuestionData]="resData.data[ind].Item11"
                        ></app-TVR-Question-subcard-info>
                      </div>
                      <div class="col-12 col-md-4 mb-2" *ngIf="resData.data[ind]?.Item12?.length">
                        <app-PD-Question-subcard-info
                          [PDQuestionData]="resData.data[ind].Item12"
                        ></app-PD-Question-subcard-info>
                      </div>
                    </div>
                    <div class="row my-2" *ngIf="resData.data[ind]?.Item13?.length">
                      <div class="col-12 col-md-4 mb-2">
                        <app-pdc-details
                          [PDCDetail]="resData.data[ind].Item13"
                        ></app-pdc-details>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Print Component Button Wrapper -->
            <div class="mt-3 text-right">
              <app-print-card
                [loanId]="loanId"
                [applicationId]="applicationId"
                [resData]="resData"
              >
              </app-print-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
